module.exports = __webpack_public_path__ + "static/media/search.ea63ae13.svg";